import React from 'react';

const Container = ({ className = '', ...props }) => {
  const containerClasses = ` w-full h-[85vh] mx-auto  ${className}`;

  return (
    <div className={containerClasses} {...props} />
  );
};

export default Container;
